var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"fancy-btn",attrs:{"text":"","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit(`click`)}}},[_c('span',{staticClass:"fancy-btn--icon"},[_c('v-icon',{attrs:{"large":""}},[_vm._v(_vm._s(_vm.icon))])],1),_c('span',{staticClass:"fancy-btn--text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }